import { WatcherFunction } from '..'
import { watchLookupYouTubeChannelRequest } from './lookupYouTubeChannel'
import { watchSaveRequest } from './save'
import { watchSyncDraftRequest } from './sync'

export const draftsSagas: ReadonlyArray<WatcherFunction> = [
  watchSaveRequest,
  watchSyncDraftRequest,
  watchLookupYouTubeChannelRequest,
]
